'use client';

import { useState, useEffect, useCallback } from 'react';
import { ArrowUp } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';
import { useTheme } from 'next-themes';

export function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const [mounted, setMounted] = useState(false);
  const { resolvedTheme } = useTheme();

  useEffect(() => { setMounted(true); }, []);
  const isDark = mounted ? resolvedTheme === 'dark' : false;

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <button
      onClick={scrollToTop}
      aria-label="Наверх"
      className={cn(
        'fixed z-40 md:hidden',
        'right-3 bottom-[72px]',
        'w-10 h-10 rounded-pill',
        'flex items-center justify-center',
        'transition-all duration-300 ease-[cubic-bezier(0.32,0.72,0,1)]',
        'active:scale-90 active:transition-none',
        visible
          ? 'opacity-100 translate-y-0 pointer-events-auto'
          : 'opacity-0 translate-y-4 pointer-events-none',
        // Кнопка «наверх» плавает над каталогом — роль float, не deep:
        // глубина оставлена только карточке товара и модалке (ответ 35 = 2).
        // Раньше тень задавалась дважды, отдельно для светлой и тёмной темы;
        // роль одна на обе, поэтому вынесена из ветвления.
        'shadow-float',
        // Стиль как у мини-корзины
        isDark
          ? 'bg-[var(--bg-primary)] md:bg-[var(--bg-primary)]/90 md:backdrop-blur-2xl border border-white/[0.08]'
          : '',
      )}
      style={
        !isDark && mounted
          ? { background: 'linear-gradient(135deg, var(--bonus-platinum), var(--primary))' }
          : undefined
      }
    >
      <ArrowUp className="w-4.5 h-4.5 text-white" weight="bold" />
    </button>
  );
}
